export default {
  contentTitle: 'Content Management',
  clipboard: 'Clipboard',
  clipboardMessage: 'Pass "admin" into the copy button',
  richText: 'Rich Text',
  threeTierStructure: 'Three-tier structure',
  virtualScroll: 'Virtual Scroll',
  virtualScroll1: 'virtual scrolling list (10000)',
  virtualScroll2: 'virtual scrolling table (10000)',
  watermark: 'Watermark',
  openWatermark: 'Open watermark',
  hideWatermark: 'Hide watermark',
  nestedData: 'Nested data',
  sensitiveInfo: 'Note: The title cannot contain sensitive information!',
  creator: 'Creator',
  updater: 'Updater',
  author: 'Author',
  companyPageTitle: 'Company Page Config',
  companyPageConfigTitle: 'Page Config',
  companyPageConfigDesc: 'Configure the hero headline, subtitle, and background image shown on the page.',
  companyIntroCard: 'Company Profile',
  companyIntroDesc: 'Manage the intro paragraphs displayed on the About page. Multiple entries supported.',
  companyHeroTitle: 'Hero title',
  companyHeroSubtitle: 'Hero subtitle',
  companyBackgroundImage: 'Background image URL',
  companyLogo: 'Company Logo',
  companyLogoExtra: 'Used for website navigation bar logo and browser tab icon',
  companyRecruitmentIntro: 'Join us introduction',
  companyContactEmail: 'Resume mailbox',
  companyContactPhone: 'Contact phone',
  companySavePageConfigSuccess: 'Page config saved locally (API not wired yet)',
  companySaveJoin: 'Save join section',
  companySaveJoinSuccess: 'Join section saved locally (API not wired yet)',
  companyAddIntro: 'Add intro',
  companyEditIntro: 'Edit intro',
  companyIntroContent: 'Intro content',
  companyHistoryTitle: 'Development Timeline',
  companyHistoryDesc: 'Maintain the timeline entries that appear in the website history section.',
  companyTimelineYear: 'Year / time',
  companyTimelineEvent: 'Event title',
  companyTimelineContent: 'Event description',
  companyAddHistory: 'Add timeline entry',
  companyEditHistory: 'Edit timeline entry',
  companyAdvantageTitle: 'Advantages',
  companyAdvDesc: 'Configure advantage label, emoji, and description.',
  companyAdvantageIcon: 'Icon / emoji',
  companyAdvantageName: 'Advantage title',
  companyAdvantageContent: 'Advantage description',
  companyAddAdvantage: 'Add advantage',
  companyEditAdvantage: 'Edit advantage',
  companyJobsTitle: 'Join Us',
  companyJobsDesc: 'Manage the positions displayed on the recruitment block.',
  companyJobName: 'Job title',
  companyJobLocation: 'Location',
  companyJobType: 'Job type',
  companyJobTag: 'Tag / salary',
  companyJobDesc: 'Job description',
  companyAddJob: 'Add position',
  companyEditJob: 'Edit position',
  companyPreviewTitle: 'Config preview (copy to website)',
  companyPreviewDesc: 'Copy the JSON and paste it into the eee site to refresh its default content.',
  companyCopySuccess: 'Configuration copied to clipboard',
  companyCopyFailed: 'Failed to copy, please select the text manually',
  companyOnlyFrontendTips: 'Demo only. Wire it to real APIs later to persist data.',
  industryConfigTitle: 'Industry Application Config',
  industryConfigDesc: 'Configure page info, description, applications, and advantages for each industry. The left industry list is fixed and cannot be configured.',
  industryPageConfig: 'Page Config',
  industryContentConfig: 'Industry Content',
  industryHeroTitle: 'Hero Title',
  industryHeroSubtitle: 'Hero Subtitle',
  industryBackgroundImage: 'Background Image',
  industryDescription: 'Description',
  industryDescriptionEn: 'Description (English)',
  industryApplications: 'Main Applications',
  industryApplicationsEn: 'Main Applications (English)',
  industryApplicationsPlaceholder: 'Enter one application per line, e.g.:\nMilitary parts marking and tracing\nWeapon identification',
  industryApplicationsHint: 'Tip: Enter one application per line, separated by line breaks',
  industryAdvantages: 'Technical Advantages',
  industryAdvantagesEn: 'Technical Advantages (English)',
  industryAdvantagesPlaceholder: 'Enter one advantage per line, e.g.:\nUltra-high precision, meeting military standards\nHigh temperature and corrosion resistance',
  industryAdvantagesHint: 'Tip: Enter one advantage per line, separated by line breaks',
  industrySaveSuccess: 'Industry config saved locally (API not wired yet)',
  industryPreviewTitle: 'Config preview (copy to website)',
  industryPreviewDesc: 'Copy the JSON and paste it into the eee site to refresh its default content.',
  industryCopySuccess: 'Configuration copied to clipboard',
  industryCopyFailed: 'Failed to copy, please select the text manually',
  industryOnlyFrontendTips: 'Demo only. Wire it to real APIs later to persist data.',
  // Home page
  homeCarouselTitle: 'Carousel Configuration',
  homeCarouselDesc: 'Configure carousel images for the homepage (images only). Recommended size: 1800 x 600px (3:1 aspect ratio). The system will automatically adapt to different screen sizes.',
  homeAdvantageTitle: 'Company Advantages Configuration',
  homeAdvantageDesc: 'Configure text content and background image for company advantages',
  homeProfileTitle: 'Company Profile Configuration',
  homeProfileDesc: 'Configure text and images for company profile',
  homeFooterTitle: 'Footer Configuration',
  homeFooterDesc: 'Configure QR code image and contact information in the Footer section',
  homeCarouselImages: 'Carousel Images',
  homeCarouselImagesRequired: 'Please upload at least one carousel image',
  homeUploadImage: 'Please upload an image',
  homeSelectImage: 'Select Image',
  homeSelectProduct: 'Please select product',
  homeClickToJump: 'Click to Jump',
  homeDelete: 'Delete',
  homeAddCarousel: 'Add Carousel Image',
  homeTitle: 'Title',
  homeSubtitle: 'Subtitle',
  homeDescription: 'Description',
  homeDescriptionEn: 'Description (English)',
  homeBackgroundImage: 'Background Image',
  homeProfileTitleEn: 'Profile Title (English)',
  homeProfileDescription: 'Profile Description',
  homeProfileDescriptionEn: 'Profile Description (English)',
  homeProfileImage: 'Profile Image',
  homeQrcodeImage: 'QR Code Image',
  homeCompanyName: 'Company Name (Chinese)',
  homeCompanyNameEn: 'Company Name (English)',
  homeAddressCn: 'Address (Chinese)',
  homeAddressEn: 'Address (English)',
  homePhone: 'Phone',
  homeEmail: 'Email',
  homeContacts: 'Contact Information',
  homeContactName: 'Contact Name',
  homeContactPhone: 'Contact Phone',
  homeAddContact: 'Add Contact',
  homeCopyright: 'Copyright Information',
  homeIcp: 'ICP License Number',
  homeInputTitle: 'Please enter title',
  homeInputSubtitle: 'Please enter subtitle',
  homeInputDescription: 'Please enter description',
  homeInputProfile: 'Please enter company profile',
  homeInputCompanyName: 'Please enter company name',
  homeInputCompanyNameEn: 'Please enter company name in English',
  homeInputAddress: 'Please enter address',
  homeInputAddressEn: 'Please enter address in English',
  homeInputPhone: 'Please enter phone number',
  homeInputEmail: 'Please enter email',
  homeInputContactName: 'Please enter contact name',
  homeInputContactPhone: 'Please enter contact phone',
  homeInputCopyright: 'Please enter copyright information',
  homeInputIcp: 'Please enter ICP license number',
  homeLoadFailed: 'Failed to load configuration',
  homeSaveSuccess: 'Saved successfully',
  homeCheckForm: 'Please check the form',
  homeSaveFailed: 'Failed to save',
  // Product page
  productConfigTitle: 'Product Configuration',
  productConfigDesc: 'Manage product categories and product information. Click the edit button next to the category name to configure category information',
  productAddProduct: 'Add Product',
  productImage: 'Image',
  productName: 'Name',
  productModel: 'Model',
  productModelEn: 'Model (English)',
  productModelEnPlaceholder: 'Product model (English)',
  productDescription: 'Description',
  productSort: 'Sort',
  productStatus: 'Status',
  productEnabled: 'Enabled',
  productDisabled: 'Disabled',
  productOperate: 'Actions',
  productEdit: 'Edit',
  productDelete: 'Delete',
  productEmpty: 'No products yet. Click "Add Product" to create',
  productEditCategory: 'Edit Category',
  productCategoryName: 'Category Name',
  productCategoryNameEn: 'English Name',
  productPageTitle: 'Page Title',
  productPageSubtitle: 'Page Subtitle',
  productCategoryDescription: 'Category Description',
  productCardImage: 'Card Image',
  productCategoryBackgroundImage: 'Background Image',
  productSortOrder: 'Sort Order',
  productIsActive: 'Status',
  productEditProduct: 'Edit Product',
  productAddProductModal: 'Add Product',
  productCategory: 'Category',
  productSelectCategory: 'Please select a category',
  productModelPlaceholder: 'Product Model',
  productNamePlaceholder: 'Product Name',
  productNameEnPlaceholder: 'Product Name (English)',
  productBriefDescription: 'Brief Description',
  productBriefDescriptionEn: 'Brief Description (English)',
  productBriefDescriptionExtra: 'Displayed on list cards',
  productBriefDescriptionPlaceholder: 'Brief product description (displayed on list page)',
  productDetailDescription: 'Detail Description',
  productDetailDescriptionEn: 'Detail Description (English)',
  productDetailDescriptionExtra: 'Displayed on product detail page',
  productDetailDescriptionPlaceholder: 'Detailed product description (displayed on detail page)',
  productCoverImage: 'Cover Image',
  productCoverImageExtra: 'Cover image displayed on list page',
  productFeatures: 'Product Features',
  productFeaturesExtra: 'One feature per line',
  productFeaturesPlaceholder: 'Product features/advantages, one per line',
  productFeaturesEn: 'Product Features (English)',
  productFeaturesEnExtra: 'One feature per line (English)',
  productFeaturesEnPlaceholder: 'Product features/advantages (English), one per line',
  productApplications: 'Applications',
  productApplicationsExtra: 'One application per line',
  productApplicationsPlaceholder: 'Application fields, one per line',
  productApplicationsEn: 'Applications (English)',
  productApplicationsEnExtra: 'One application per line (English)',
  productApplicationsEnPlaceholder: 'Application fields (English), one per line',
  productSpecs: 'Specifications',
  productSpecsExtra: 'Format: parameter:value or parameter：value, one per line (supports both English and Chinese colon)',
  productSpecsPlaceholder: 'e.g.:\nPower:50W\nWavelength:1064nm\nMarking Range:110×110mm',
  productSpecsEn: 'Specifications (English)',
  productSpecsEnExtra: 'Format: parameter:value or parameter：value, one per line (English, supports both English and Chinese colon)',
  productSpecsEnPlaceholder: 'e.g.:\nPower:50W\nWavelength:1064nm\nMarking Range:110×110mm',
  productLoadFailed: 'Failed to load configuration',
  productCategoryUpdateSuccess: 'Category configuration updated successfully',
  productSaveFailed: 'Failed to save',
  productUpdateSuccess: 'Product updated successfully',
  productCreateSuccess: 'Product created successfully',
  productDeleteSuccess: 'Deleted successfully',
  productDeleteFailed: 'Failed to delete',
  productConfirmDelete: 'Confirm Delete',
  productConfirmDeleteContent: 'Are you sure you want to delete "{{name}}"?',
  productConfirm: 'Confirm',
  productCancel: 'Cancel',
  productSortHint: 'Smaller numbers appear first',
  productCategoryDescriptionPlaceholder: 'Brief description of the category',
  productPageTitlePlaceholder: 'Category detail page title',
  productPageSubtitlePlaceholder: 'Category detail page subtitle',
  productCategoryNamePlaceholder: 'e.g.: Marking Machine',
  productCategoryNameEnPlaceholder: 'e.g.: Marking Machine',
  // Contact page
  contactPageConfig: 'Page Configuration',
  contactPageConfigDesc: 'Configure the title, subtitle, and background image for the "Contact Us" page on the website. The frontend will read and display these in real-time.',
  contactSubmit: 'Submit',
  contactPageTitle: 'Page Title',
  contactPageSubtitle: 'Page Subtitle',
  contactBackgroundImage: 'Background Image',
  contactInfoConfig: 'Contact Information Configuration',
  contactInfoConfigDesc: 'Configure company phone numbers, email addresses, and company address. This information will be displayed on the "Contact Us" page of the website.',
  contactPhone: 'Phone Number',
  contactPhoneTooltip: 'You can add multiple phone numbers, each with a contact description',
  contactPhoneNumber: 'Phone',
  contactPhoneDescription: 'Contact/Description',
  contactAddPhone: 'Add Phone Number',
  contactEmail: 'Email Address',
  contactEmailTooltip: 'You can add multiple email addresses, each with a usage description',
  contactEmailAddress: 'Email',
  contactEmailDescription: 'Usage/Description',
  contactAddEmail: 'Add Email Address',
  contactAddress: 'Company Address',
  contactInputPageTitle: 'Please enter page title',
  contactInputPageSubtitle: 'Please enter page subtitle',
  contactUploadBackgroundImage: 'Please upload background image',
  contactInputPhone: 'Please enter phone number',
  contactInputEmail: 'Please enter email address',
  contactInputValidEmail: 'Please enter a valid email address',
  contactInputAddress: 'Please enter company address',
  contactPhonePlaceholder: 'e.g.: 400-888-8888',
  contactPhoneDescriptionPlaceholder: 'e.g.: Customer Service Hotline, Sales Inquiry, etc.',
  contactEmailPlaceholder: 'e.g.: contact@chuangtian.com',
  contactEmailDescriptionPlaceholder: 'e.g.: Business Cooperation, Technical Support, After-sales Service, etc.',
  contactAddressPlaceholder: 'e.g.: Science Park, Nanshan District, Shenzhen, Guangdong, China',
  contactPageTitlePlaceholder: 'e.g.: Contact Us',
  contactPageSubtitlePlaceholder: 'e.g.: Contact Us',
  contactLoadFailed: 'Failed to load configuration',
  contactSaveSuccess: 'Saved successfully',
  contactSaveFailed: 'Failed to save',
  contactPageConfigSaveSuccess: 'Page configuration saved successfully',
  contactPageConfigSaveFailed: 'Failed to save page configuration',
  contactConfirmDeletePhone: 'Are you sure you want to delete this phone number?',
  contactConfirmDeleteEmail: 'Are you sure you want to delete this email address?',
};
